module.exports = __webpack_public_path__ + "img/poziom10.070cc711.svg";